module.exports = __webpack_public_path__ + "img/syzn_02.2647c106.jpg";